import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

/**
 * Pass the basic data in the constructor, like the entityId, and avoids repeating the same info in
 * every request of translation.
 */
var Translation = function Translation() {
  var _this = this;

  var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var language = arguments.length > 1 ? arguments[1] : undefined;
  var entityId = arguments.length > 2 ? arguments[2] : undefined;

  _classCallCheck(this, Translation);

  _defineProperty(this, "translate", function (fieldName) {
    var labelTranslated = null;

    if (_Array$isArray(_this.labels)) {
      // Old format. An array of objects with entityType, entityId
      var filteredObject = _this.labels.filter(function (label) {
        return _this.language && label.key.localeCode.toLowerCase() === _this.language.toLowerCase() && label.key.fieldName === fieldName && label.key.entityId === _this.entityId;
      });

      if (filteredObject.length > 0) {
        labelTranslated = filteredObject[0].value;
      } else if (_this.labels.length > 0) {
        labelTranslated = "##".concat(fieldName, "##");
      }
    } else {
      // New format. An object with the right keys already
      labelTranslated = _this.labels[fieldName] || "##".concat(fieldName, "##");
    }

    return labelTranslated;
  });

  if (_Array$isArray(labels)) {
    // Old format. An array of objects with entityType, entityId
    // Keeps only the labels of the passed entityId
    this.labels = labels.filter(function (item) {
      return item.key.entityId === entityId;
    });
  } else {
    // New format. An object with the right keys already
    this.labels = labels.Label[entityId] || {};
  }

  this.language = language;
  this.entityId = entityId;
};

export default Translation;